module.exports = __webpack_public_path__ + "static/media/whatsapp.c9dd764d.png";